<template>
        <div class="popup">
            <div class="popup_div">
                <!-- 礼物动态区 -->
                <div id="demoCanvasA">
    
                </div>
            </div>
        </div>
    </template>
    
    <script>
        import SVGA from "svgaplayerweb"//引用svga
        export default {
            name: 'popup',
            data() {
                return {
                    is_animation:true,//动画
                    player:'',
                    parser:"",
                    num:0,
                }
            },
            props: {
                gift_arrA:{
                    type:Array,
                },
            },
            methods: {
                SVGA() { 
                    let demoCanvas = document.getElementById("demoCanvasA");
                    let that = this;
                    // demoCanvas.forEach((liem,index)=>{
    
                    let player = new SVGA.Player(demoCanvas);
                    let parser = new SVGA.Parser(demoCanvas);
                    let num_att = 0;
                    parser.load(this.$VIEW_URL+'/svga/点赞.svga', function (videoItem) {
                        player.loops = 1;
                        player.clearsAfterStop = true;
                        player.setVideoItem(videoItem);
                        player.startAnimation();
                        player.onFrame(function (i) {
                            num_att = i;
                        });
                        player.onFinished(function(){//动画结束
                             
                            player.stopAnimation();
                            that.is_animation = true;
                            that.downGift();
                            
                        })
                    
                    });
                    
                    
                },
                setFill() {               //适配不同屏
                    let that = this;
                    var $_canvas = document.getElementById("demoCanvasA"),
                    w = $('#demoCanvasA').width(),
                    h = $('#demoCanvasA').height(),
                    screen_proportion = h / w,
                    svga_proportion = 16 / 9;
    
                    if (screen_proportion > svga_proportion) {
                        //长屏幕
                        // $_canvas.style.width = h / svga_proportion + "px";
                        // $_canvas.style.left = (w - h / svga_proportion) / 2 + "px";
                    } else {
                        // $_canvas.style.height = w * svga_proportion + "px";
                        // $_canvas.style.top = (h - w * svga_proportion) / 2 + "px";
                    }
                },
                downGift(){
                    let that = this;
                    if(this.gift_arrA.length>0 && this.is_animation){
                        this.is_animation = false;
                        this.$emit('giftFunA');
                        this.setFill();
                        this.$nextTick(()=>{
                            that.SVGA();
                        })
                    }
                    
                },
    
            },
            mounted() {
                this.downGift();
                
            },
        }
    </script>
    
    <!-- Add "scoped" attribute to limit CSS to this component only -->
    <style scoped>
        .popup {
          
        }
    
        .popup .popup_div {
          
        }
    
        #demoCanvasA{
            width: 300px;
            height: 300px;
            position: absolute;
            bottom:0;
            right: 0;
            /* border:.005rem solid #ff0000; */
        }
    </style>


// WEBPACK FOOTER //
// src/components/assembly/GiftA.vue